<script>
    import InfiniteScroll from 'infinite-scroll';
    import imagesLoaded from 'imagesloaded';
    import Masonry from 'masonry-layout';
    import { mountVue } from 'utils/vueContainer';
    import Vue from 'vue';
    import { mapMutations } from 'vuex';

    /**
     * Small utility function which will trigger the callback once the video is loaded
     */
    function videosLoaded(_container, callback) {
        let videos = _container.querySelectorAll('video');
        if (videos.length) {
            for (let i = 0; i < videos.length; i++) {
                const video = videos[i];
                const eventFn = () => {
                    video.removeEventListener('loadeddata', eventFn, false);
                    callback();
                };
                video.addEventListener('loadeddata', eventFn, false);
            }
        }
    }

    export default {
        name: 'Fragments',
        data () {
            return {
                hidePagination: false,
                msnry: {},
                infScroll: {},
                timeout: false
            }
        },
        props: {
            infinite: {
                type: Boolean,
                default: true,
            }
        },
        methods: {
            ...mapMutations({
                setLoading: 'app/setLoading',
            }),
            init() {
                let container = this.$refs.container;

                this.msnry = new Masonry(container, {
                    itemSelector: '[data-fragment]',
                    percentPosition: true,
                    transitionDuration: '0.5s',
                    stagger: 20,
                    visibleStyle: { transform: 'translateY(0)', opacity: 1 },
                    hiddenStyle: { transform: 'translateY(100px)', opacity: 0 },
                });

                imagesLoaded(container, () => {
                    this.msnry.options.itemSelector = '[data-fragment]';
                    var items = container.querySelectorAll('[data-fragment]');
                    this.msnry.layout();
                });

                // videosLoaded(container, () => {
                //    this.msnry.layout();
                // });

                /* Bugfix: Initialize InfiniteScroll with a delay so it runs *after* any transitions */
                if (this.infinite == true) {
                    this.timeout = setTimeout(() => {
                        this.infiniteScroll();
                    }, 500);
                }
            },
            infiniteScroll() {
                InfiniteScroll.imagesLoaded = imagesLoaded;

                this.infScroll = new InfiniteScroll('[data-fragments-container]', {
                    // options
                    path: '[data-fragments-next]',
                    append: '[data-fragment]',
                    outlayer: this.msnry,
                    history: false,
                    prefill: true,
                    debug: true
                });

                this.infScroll.on('request', () => {
                    this.setLoading(true);
                });

                this.infScroll.on('error', () => {
                    this.setLoading(false);
                });

                this.infScroll.on('append', (response, path, items) => {
                    this.setLoading(false);

                    this.msnry.layout();

                    // videosLoaded(container, () => {
                    //     this.msnry.layout();
                    // });

                    // Mount appended vue components manually
                    for (let i = 0; i < items.length; i++) {
                        let element = items[i].querySelector('.fragment');
                        let newV = new Vue({el: element});
                    }
                });

                this.hidePagination = true;
            }
        },
        mounted() {
            this.init();
        },
        beforeDestroy () {
            if (this.timeout) clearTimeout(this.timeout);
            if (this.infScroll.destroy) this.infScroll.destroy();
            this.msnry.destroy();
            this.setLoading(false);
        }
    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Fragments.vue